import { render, staticRenderFns } from "./CircleVideoList.vue?vue&type=template&id=28c8e4ee&scoped=true"
import script from "./CircleVideoList.vue?vue&type=script&lang=js"
export * from "./CircleVideoList.vue?vue&type=script&lang=js"
import style0 from "./CircleVideoList.vue?vue&type=style&index=0&id=28c8e4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8e4ee",
  null
  
)

export default component.exports